__turbopack_context__.v({
  "extView": "ExtensionActionView-module__UW6BKa__extView",
  "extViewBody": "ExtensionActionView-module__UW6BKa__extViewBody",
  "extViewContent": "ExtensionActionView-module__UW6BKa__extViewContent",
  "extViewDevInfo": "ExtensionActionView-module__UW6BKa__extViewDevInfo",
  "extViewPlaceholder": "ExtensionActionView-module__UW6BKa__extViewPlaceholder",
});
